import PriceCatalogFilters from './PriceCatalogFilters';

export default PriceCatalogFilters;
